// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom Turing input styles based on Antd */

/* Default input */

.ant-input{
  height: 40px;
  padding: 10px 12px;
  background-color: #FFFFFF;
  border: 1px solid #CCCCCC !important;
  border-radius: 4px;
  color: #444444;
  font-size: 16px;
  box-shadow: 0 0 0 transparent !important;
}

/* Default input - placeholder */

.ant-input::placeholder{
  color: #CCCCCC;
}

/* Default input - hover */

.ant-input:hover{
  border: 1px solid #888888 !important;
  box-shadow: 0 1px 2px rgba(136, 136, 136, 0.16) !important;
}

/* Default input - focus */

.ant-input:focus{
  border: 1px solid #42A5F5 !important;
  box-shadow: 0 1px 2px rgba(66, 165, 245, 0.2) !important;
}

/* Default input - disabled */

.ant-input:disabled {
  background-color: #EEEEEE;
  border: 1px solid #CCCCCC !important;
  color: #AAAAAA;
  font-size: 16px;
  box-shadow: 0 0 0 transparent !important;
}

/* Default input - error state */

.ant-input.error {
  background-color: #FFFFFF;
  border: 1px solid #EF5350 !important;
  box-shadow: 0 0 0 transparent !important;
}

/* --- */

/* Input - group of elements */

.input-group{
  width: 100%;
}

.input-name{
  color: #212121;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
}

.input-helper{
  color: #888888;
  font-size: 11px;
  line-height: 15px;
  margin-top: 6px;
}

/* Input - group of elements - disabled state */

.input-group.disabled{

}

.input-group.disabled .input-name{
  color: #AAAAAA;
}

.input-group.disabled .input-helper{
  color: #CCCCCC;
}

/* Input - group of elements - error state */

.input-group.error{

}

.input-group.error .input-helper{
  color: #EF5350;
}

/* Input - with icon */

.input-group.with-icon{

}

.input-field-holder{
  position: relative;
  margin: 0;
  padding: 0;
}

.input-field-holder.icon-left input{
  padding-left: 38px;
}
.input-field-holder.icon-right input{
  padding-right: 38px;
}

.input-field-holder .input-icon{
  color: #444444;
  position: absolute;
  top: 8px;
}
.input-field-holder.icon-left .input-icon{
  left: 12px;
}
.input-field-holder.icon-right .input-icon{
  right: 12px;
}

    /* Icon on both sides  */
    .input-field-holder.icon-left-right input{
      padding-left: 38px;
      padding-right: 38px;
    }

    .input-field-holder.icon-left-right .input-icon.is-left{
      left: 12px;
    }
    .input-field-holder.icon-left-right .input-icon.is-right{
      right: 12px;
    }

/* Input - with icon - disabled state */

.input-group.with-icon.disabled .input-field-holder .input-icon{
  color: #AAAAAA;
}

/* Input - with icon - error state */

.input-group.with-icon.error .input-name{
  color: #212121;
}

.input-group.with-icon.error .input-field-holder .input-icon{
  color: #EF5350;
}

/* Character counter */

.input-helper.character-counter{
  text-align: right;
}

.input-helper.character-counter .splitter{
  margin-left: 3px;
  margin-right: 3px;
}

/* Prefix */

.input-group.has-prefix{

}

.input-group.has-prefix input{
  padding-left: 38px;
}

.input-group.has-prefix .input-prefix{
  position: absolute;
  top: 8px;
  left: 12px;
  color: #AAAAAA;
  font-size: 16px;
}

/* Suffix */

.input-group.has-suffix{

}

.input-group.has-suffix input{
  padding-left: 12px;
}

.input-group.has-suffix .input-suffix{
  position: absolute;
  top: 8px;
  left: 48px;
  color: #AAAAAA;
  font-size: 16px;
}

/* Dense */

.input-group.has-dense{

}

.input-group.has-dense input.input-dense{
  height: 32px;
  padding: 7px 12px;
  background-color: #FFFFFF;
  border: 1px solid #CCCCCC !important;
  border-radius: 4px;
  color: #444444;
  font-size: 14px !important;
  box-shadow: 0 0 0 transparent !important;
}

.input-group.with-icon.no-border .input-icon{
  color: #888888;
}

.input-group.with-icon.no-border .input-icon.is-left{
  left: 0;
}
.input-group.with-icon.no-border .input-icon.is-right{
  right: 0;
}

.input-no-border{
  padding-left: 36px !important;
  border: none !important;
}

.input-no-border:hover, .input-no-border:focus{
  border: none !important;
  box-shadow: 0 0 0 transparent !important
}

.input-group .ant-input,
.input-group .ant-select {
  width: 100%;
}

.ant-select-selection--single {
  height: 40px !important;
  padding-top: 5px !important;
}

/* Custom Turing textarea styles based on Antd */

textarea.ant-input{
  min-height: 80px;
  height: 80px;
}

/* Dense */

.input-group.has-dense{

}

.input-group.has-dense textarea.input-dense{
  min-height: 64px;
  height: 64px;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/TextField/TextField.css"],"names":[],"mappings":";AACA,6CAA6C;;AAE7C,kBAAkB;;AAElB;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA,gCAAgC;;AAEhC;EACE,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;EACE,oCAAoC;EACpC,0DAA0D;AAC5D;;AAEA,0BAA0B;;AAE1B;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA,6BAA6B;;AAE7B;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA,gCAAgC;;AAEhC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,QAAQ;;AAER,8BAA8B;;AAE9B;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,+CAA+C;;AAE/C;;AAEA;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;;AAE5C;;AAEA;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;;AAEtB;;AAEA;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;IAEI,wBAAwB;IACxB;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,UAAU;IACZ;IACA;MACE,WAAW;IACb;;AAEJ,uCAAuC;;AAEvC;EACE,cAAc;AAChB;;AAEA,oCAAoC;;AAEpC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;;AAEtB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;;AAEA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;;AAEX;;AAEA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA,UAAU;;AAEV;;AAEA;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,gDAAgD;;AAEhD;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,UAAU;;AAEV;;AAEA;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["\n/* Custom Turing input styles based on Antd */\n\n/* Default input */\n\n.ant-input{\n  height: 40px;\n  padding: 10px 12px;\n  background-color: #FFFFFF;\n  border: 1px solid #CCCCCC !important;\n  border-radius: 4px;\n  color: #444444;\n  font-size: 16px;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n/* Default input - placeholder */\n\n.ant-input::placeholder{\n  color: #CCCCCC;\n}\n\n/* Default input - hover */\n\n.ant-input:hover{\n  border: 1px solid #888888 !important;\n  box-shadow: 0 1px 2px rgba(136, 136, 136, 0.16) !important;\n}\n\n/* Default input - focus */\n\n.ant-input:focus{\n  border: 1px solid #42A5F5 !important;\n  box-shadow: 0 1px 2px rgba(66, 165, 245, 0.2) !important;\n}\n\n/* Default input - disabled */\n\n.ant-input:disabled {\n  background-color: #EEEEEE;\n  border: 1px solid #CCCCCC !important;\n  color: #AAAAAA;\n  font-size: 16px;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n/* Default input - error state */\n\n.ant-input.error {\n  background-color: #FFFFFF;\n  border: 1px solid #EF5350 !important;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n/* --- */\n\n/* Input - group of elements */\n\n.input-group{\n  width: 100%;\n}\n\n.input-name{\n  color: #212121;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 8px;\n}\n\n.input-helper{\n  color: #888888;\n  font-size: 11px;\n  line-height: 15px;\n  margin-top: 6px;\n}\n\n/* Input - group of elements - disabled state */\n\n.input-group.disabled{\n\n}\n\n.input-group.disabled .input-name{\n  color: #AAAAAA;\n}\n\n.input-group.disabled .input-helper{\n  color: #CCCCCC;\n}\n\n/* Input - group of elements - error state */\n\n.input-group.error{\n\n}\n\n.input-group.error .input-helper{\n  color: #EF5350;\n}\n\n/* Input - with icon */\n\n.input-group.with-icon{\n\n}\n\n.input-field-holder{\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n\n.input-field-holder.icon-left input{\n  padding-left: 38px;\n}\n.input-field-holder.icon-right input{\n  padding-right: 38px;\n}\n\n.input-field-holder .input-icon{\n  color: #444444;\n  position: absolute;\n  top: 8px;\n}\n.input-field-holder.icon-left .input-icon{\n  left: 12px;\n}\n.input-field-holder.icon-right .input-icon{\n  right: 12px;\n}\n\n    /* Icon on both sides  */\n    .input-field-holder.icon-left-right input{\n      padding-left: 38px;\n      padding-right: 38px;\n    }\n\n    .input-field-holder.icon-left-right .input-icon.is-left{\n      left: 12px;\n    }\n    .input-field-holder.icon-left-right .input-icon.is-right{\n      right: 12px;\n    }\n\n/* Input - with icon - disabled state */\n\n.input-group.with-icon.disabled .input-field-holder .input-icon{\n  color: #AAAAAA;\n}\n\n/* Input - with icon - error state */\n\n.input-group.with-icon.error .input-name{\n  color: #212121;\n}\n\n.input-group.with-icon.error .input-field-holder .input-icon{\n  color: #EF5350;\n}\n\n/* Character counter */\n\n.input-helper.character-counter{\n  text-align: right;\n}\n\n.input-helper.character-counter .splitter{\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n/* Prefix */\n\n.input-group.has-prefix{\n\n}\n\n.input-group.has-prefix input{\n  padding-left: 38px;\n}\n\n.input-group.has-prefix .input-prefix{\n  position: absolute;\n  top: 8px;\n  left: 12px;\n  color: #AAAAAA;\n  font-size: 16px;\n}\n\n/* Suffix */\n\n.input-group.has-suffix{\n\n}\n\n.input-group.has-suffix input{\n  padding-left: 12px;\n}\n\n.input-group.has-suffix .input-suffix{\n  position: absolute;\n  top: 8px;\n  left: 48px;\n  color: #AAAAAA;\n  font-size: 16px;\n}\n\n/* Dense */\n\n.input-group.has-dense{\n\n}\n\n.input-group.has-dense input.input-dense{\n  height: 32px;\n  padding: 7px 12px;\n  background-color: #FFFFFF;\n  border: 1px solid #CCCCCC !important;\n  border-radius: 4px;\n  color: #444444;\n  font-size: 14px !important;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.input-group.with-icon.no-border .input-icon{\n  color: #888888;\n}\n\n.input-group.with-icon.no-border .input-icon.is-left{\n  left: 0;\n}\n.input-group.with-icon.no-border .input-icon.is-right{\n  right: 0;\n}\n\n.input-no-border{\n  padding-left: 36px !important;\n  border: none !important;\n}\n\n.input-no-border:hover, .input-no-border:focus{\n  border: none !important;\n  box-shadow: 0 0 0 transparent !important\n}\n\n.input-group .ant-input,\n.input-group .ant-select {\n  width: 100%;\n}\n\n.ant-select-selection--single {\n  height: 40px !important;\n  padding-top: 5px !important;\n}\n\n/* Custom Turing textarea styles based on Antd */\n\ntextarea.ant-input{\n  min-height: 80px;\n  height: 80px;\n}\n\n/* Dense */\n\n.input-group.has-dense{\n\n}\n\n.input-group.has-dense textarea.input-dense{\n  min-height: 64px;\n  height: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
